module.exports = __webpack_public_path__ + "1_0_60/img/check_mark.93100f1b.svg";